import {  SellerRoleEnum } from 'v3/data/store/seller/enum';
import { ISeller } from 'v3/data/store/seller/types';

export const createSeller = (
  data: Partial<ISeller> & {
    name?: string;
    code?: string;
    active?: boolean;
    storeId?: string;
    profileId?: string | null;
  },
): ISeller => {
  return {
    id: data.id ?? '',
    active: data.active ?? false,
    name: data.name ?? '',
    code: data.code ?? '',
    role: data.role ?? SellerRoleEnum.Seller,
    storeId: data.storeId ?? '',
    profileId: data.profileId ?? undefined,
    store: data.store ?? undefined,
  };
};
